angular.module('signalview.detector.rule', ['signalview.utils']);
